import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { SlotListResponse } from '@frontend/slot/types';

export class SlotTransactionClient extends APIClient {
    public static readonly endpoint = '/slot-api/v1';

    static async fetchSpotTransactionSlots(spotId: string, transactionId: string, queryParams?: ApiQueryParams<DefaultQueryParams>): Promise<SlotListResponse> {
        return this.apiPaginated<SlotListResponse, DefaultQueryParams>(`${this.endpoint}/spots/${spotId}/transactions/${transactionId}/slots`, queryParams);
    }
}
